// ChatLinkGeneratorPage.js
import React from 'react';
import {
  Container,
  Paper,
  Typography,
  Box,
  Breadcrumbs,
  Link,
  Divider
} from '@mui/material';
import {
  Home as HomeIcon
} from '@mui/icons-material';
import ChatLinkGenerator from './ChatLinkGenerator';

/**
 * Standalone page for generating chat invitation links
 * This page can be accessed directly from navigation menus
 */
const ChatLinkGeneratorPage = () => {
  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 6 }}>
      <Box sx={{ mb: 3 }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link 
            underline="hover" 
            color="inherit" 
            href="/dashboard"
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            Dashboard
          </Link>
          <Typography color="text.primary" sx={{ display: 'flex', alignItems: 'center' }}>
            Chat Invitations
          </Typography>
        </Breadcrumbs>
      </Box>

      <Paper elevation={2} sx={{ p: 4 }}>
        <Typography variant="h5" gutterBottom>
          Invite Clients
        </Typography>
        
        <Typography variant="body1" color="text.secondary" paragraph>
          Generate links to invite clients to chat with you. Share these links via email, text message, or any communication platform.
        </Typography>
        
        <Divider sx={{ my: 3 }} />
        
        <ChatLinkGenerator />
        
        <Box sx={{ mt: 4 }}>
          <Typography variant="h6" gutterBottom>
            How It Works
          </Typography>
          
          <Box component="ol" sx={{ pl: 2 }}>
            <Box component="li" sx={{ mb: 1 }}>
              <Typography variant="body1">
                Generate a unique invitation link that's valid for 7 days
              </Typography>
            </Box>
            <Box component="li" sx={{ mb: 1 }}>
              <Typography variant="body1">
                Share the link with your client via email, text message, or other communication platforms
              </Typography>
            </Box>
            <Box component="li" sx={{ mb: 1 }}>
              <Typography variant="body1">
                When your client clicks the link, they'll be prompted to enter their name and email
              </Typography>
            </Box>
            <Box component="li">
              <Typography variant="body1">
                After submitting their information, a chat room will be automatically created and your client will be connected to you
              </Typography>
            </Box>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default ChatLinkGeneratorPage;